<div class="bg-app-bar px-6 h-16 border-b sticky left-0 flex items-center">
    <h2 class="title my-0 ltr:pr-4 rtl:pl-4 ltr:mr-4 rtl:ml-4 ltr:border-r rtl:border-l hidden sm:block flex-none">
        <span>Histórico de informes</span>
    </h2>
    <button class="text-secondary ml-auto" mat-dialog-close mat-icon-button type="button">
        <mat-icon svgIcon="mat:close"></mat-icon>
    </button>
</div>
<div class="overflow-auto max-h-[30rem]">
    <table @stagger id="top" [dataSource]="dataSource" class="w-full" multiTemplateDataRows mat-table matSort matTableFilter
        matSortDirection="desc" (matSortChange)="sortData($event)">

        <ng-container matColumnDef="expandIni">
            <th class="uppercase" mat-header-cell *matHeaderCellDef aria-label="row actions">&nbsp;</th>
            <td mat-cell *matCellDef="let element"
                (click)="expandedElement = expandedElement === element ? null : element; loadDocuments(element,expandedElement);$event.stopPropagation()"
                [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">
                <mat-icon svgIcon="mat:keyboard_arrow_down" *ngIf="expandedElement !== element"></mat-icon>
                <mat-icon svgIcon="mat:keyboard_arrow_up" *ngIf="expandedElement === element"></mat-icon>
            </td>
        </ng-container>

        <ng-container matColumnDef="checkbox">
            <th *matHeaderCellDef mat-header-cell>
                <mat-checkbox *ngIf="!uniqueSelect && visible"
                    (change)="$event ? masterToggle() : null"
                    [checked]="selection.hasValue() && isAllSelected()"
                    [indeterminate]="selection.hasValue() && !isAllSelected()" color="primary">
                </mat-checkbox>
            </th>
            <td *matCellDef="let row" class="w-4" mat-cell>
                <mat-checkbox (change)="$event ? selectFile(row) : null" (click)="$event.stopPropagation()"
                    [checked]="selection.isSelected(row)" color="primary">
                </mat-checkbox>
            </td>
        </ng-container>

        <ng-container *ngFor="let column of columns; trackBy: trackByProperty">
            <ng-container *ngIf="column.type === 'text' || column.type === 'textarea'"
                [matColumnDef]="column.property">
                <th *matHeaderCellDef class="uppercase" mat-header-cell mat-sort-header> {{ column.label }}</th>
                <td *matCellDef="let row" [ngClass]="column.cssClasses" mat-cell>{{ row[column.property] }}</td>
            </ng-container>

            <ng-container *ngIf="column.type === 'select'" [matColumnDef]="column.property">
                <th *matHeaderCellDef class="uppercase" mat-header-cell mat-sort-header> {{ column.label }}</th>
                <td *matCellDef="let row" [ngClass]="column.cssClasses" mat-cell>{{ row[column.property]?.name || '' }}</td>
            </ng-container>

            <ng-container *ngIf="column.type === 'date'" [matColumnDef]="column.property">
                <th *matHeaderCellDef class="uppercase" mat-header-cell mat-sort-header> {{ column.label }}</th>
                <td *matCellDef="let row" [ngClass]="column.cssClasses" mat-cell>{{ row[column.property] | date:'dd/MM/yyyy' }}</td>
            </ng-container>

            <ng-container *ngIf="column.type === 'number'" [matColumnDef]="column.property">
                <th *matHeaderCellDef class="text-right uppercase" mat-header-cell> {{ column.label }}</th>
                <td class="text-right" *matCellDef="let row"
                    [ngStyle]="{'color':getColor(row[column.property])}" mat-cell>
                    {{ row[column.property] || 0 | number:'1.0-2':'es'}} €</td>
            </ng-container>

            <ng-container *ngIf="column.type === 'flag'" [matColumnDef]="column.property">
                <th *matHeaderCellDef class="uppercase" mat-header-cell> {{ column.label }}</th>
                <td mat-cell *matCellDef="let row">
                    <mat-checkbox
                        color="primary" [checked]="row.isSent == 1" [disabled]="true"
                        class="hover:bg-hover" [class.mat-checkbox-disabled]="false">
                    </mat-checkbox>
                </td>
            </ng-container>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th *matHeaderCellDef mat-header-cell></th>
          <td *matCellDef="let row" class="w-10 text-secondary" mat-cell>
            <button (click)="$event.stopPropagation()" [matMenuTriggerData]="{ element: row }"
              [matMenuTriggerFor]="actionsMenu" mat-icon-button type="button">
              <mat-icon svgIcon="mat:more_horiz"></mat-icon>
            </button>
          </td>
        </ng-container>

        <ng-container matColumnDef="expandedDetail">
            <td mat-cell *matCellDef="let element" [attr.colspan]="visibleColumns.length">
                <div
                    *ngIf="element === expandedElement"
                    class="example-element-detail"
                    [@detailExpand]="element === expandedElement ? 'expanded' : 'collapsed'">

                    <table mat-table [dataSource]="documentsDataSource" multiTemplateDataRows>

                        <ng-container matColumnDef="expandDoc">
                            <th mat-header-cell *matHeaderCellDef aria-label="row actions">&nbsp;</th>
                            <td mat-cell *matCellDef="let document" class="cursor-pointer"
                                (click)="expandedDocument = expandedDocument === document ? null : document; $event.stopPropagation()">
                                <mat-icon svgIcon="mat:keyboard_arrow_down" *ngIf="expandedDocument !== document"></mat-icon>
                                <mat-icon svgIcon="mat:keyboard_arrow_up" *ngIf="expandedDocument === document"></mat-icon>
                            </td>
                        </ng-container>

                        <ng-container *ngFor="let column of documentColumns; trackBy: trackByProperty">
                        <ng-container *ngIf="column.type === 'text' || column.type === 'textarea'" [matColumnDef]="column.property">
                            <th mat-header-cell *matHeaderCellDef class="uppercase">{{ column.label }}</th>
                            <td mat-cell *matCellDef="let document" [ngClass]="column.cssClasses">{{ document[column.property] }}</td>
                        </ng-container>

                        <ng-container *ngIf="column.type === 'select'" [matColumnDef]="column.property">
                            <th mat-header-cell *matHeaderCellDef class="uppercase">{{ column.label }}</th>
                            <td mat-cell *matCellDef="let document" [ngClass]="column.cssClasses">{{ document[column.property]?.name }}</td>
                        </ng-container>

                        <ng-container *ngIf="column.type === 'date'" [matColumnDef]="column.property">
                            <th mat-header-cell *matHeaderCellDef class="uppercase">{{ column.label }}</th>
                            <td mat-cell *matCellDef="let document">{{ document[column.property] | date: 'dd/MM/yyyy' }}</td>
                        </ng-container>

                        </ng-container>

                        <ng-container matColumnDef="expandedVehicleDetail">
                            <td mat-cell *matCellDef="let document" [attr.colspan]="visibleDocumentColumns.length">
                                <div *ngIf="document === expandedDocument" class="example-element-detail"
                                    [@detailExpand]="document === expandedDocument ? 'expanded' : 'collapsed'">
                                    <div *ngIf="document.vehicles?.length > 0" class="py-2 px-4">
                                        <div *ngFor="let v of document.vehicles" class="py-1">
                                            {{ v.brand?.name }} {{ v.model?.name }} - {{ v.vin }}
                                        </div>
                                    </div>
                                    <div *ngIf="!document.vehicles?.length" class="py-2 px-4 text-secondary">
                                        Sin vehículos
                                    </div>
                                </div>
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="visibleDocumentColumns"></tr>
                        <tr mat-row *matRowDef="let document; columns: visibleDocumentColumns;"
                            class="example-element-row" [class.example-expanded-row]="expandedDocument === document"></tr>
                        <tr mat-row *matRowDef="let document; columns: ['expandedVehicleDetail']" class="example-detail-row"></tr>

                    </table>
                </div>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="visibleColumns"></tr>
        <tr @fadeInUp mat-row *matRowDef="let element; columns: visibleColumns;"
        class="example-element-row  " [class.example-expanded-row]="expandedElement === element">
        </tr>
        <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>

    </table>
</div>


<mat-paginator (page)="onPaginateChange($event)" showFirstLastButtons [pageSizeOptions]="pageSizeOptions"
    [pageSize]="pageSize" class="sticky left-0"></mat-paginator>

<mat-menu #actionsMenu="matMenu" xPosition="before" yPosition="below">
  <ng-template let-element="element" matMenuContent>
    <button (click)="export(element, true)" mat-menu-item>
      <mat-icon svgIcon="mat:open_in_new"></mat-icon>
      <span>Previsualizar</span>
    </button>
    <button (click)="export(element, false)" mat-menu-item>
      <mat-icon svgIcon="mat:download"></mat-icon>
      <span>Descargar</span>
    </button>
    <button mat-menu-item (click)="send(element)">
      <mat-icon svgIcon="mat:send"></mat-icon>
      <span >Enviar</span>
    </button>
  </ng-template>
</mat-menu>
